import { BarsOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Divider, Dropdown, Input, Switch } from 'antd';
import { useCallback, useState } from 'react';
import * as S from './styles';

export type ColumnGroup = {
  label: string;
  columns: Array<{ key: string; label: string }>;
};

type Props = {
  groups: ColumnGroup[];
  visibleKeys: string[];
  onToggle: (key: string) => void;
  onReset: () => void;
};

export default function ColumnVisibilityDropdown({
  groups,
  visibleKeys,
  onToggle,
  onReset,
}: Props) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleVisibleChange = useCallback((visible: boolean) => {
    if (!visible) setSearchQuery('');
  }, []);

  const query = searchQuery.toLowerCase();

  const filteredGroups = groups
    .map((group) => ({
      ...group,
      columns: query
        ? group.columns.filter((column) =>
            column.label.toLowerCase().includes(query),
          )
        : group.columns,
    }))
    .filter((group) => group.columns.length > 0);

  const panel = (
    <S.DropdownPanel role="dialog" aria-label="Gerenciar colunas">
      <S.PanelHeader>
        <S.PanelTitle>Gerenciar colunas</S.PanelTitle>
        <S.ResetLink type="button" onClick={onReset}>
          Restaurar padrão
        </S.ResetLink>
      </S.PanelHeader>

      <S.SearchWrapper>
        <Input
          placeholder="Buscar coluna..."
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
          allowClear
          size="small"
        />
      </S.SearchWrapper>

      <S.ColumnList>
        {filteredGroups.map((group, index) => (
          <div key={group.label}>
            {index > 0 && <Divider style={{ margin: 0 }} />}
            <S.GroupLabel>{group.label}</S.GroupLabel>
            {group.columns.map((column) => (
              <S.ColumnRow
                key={column.key}
                onClick={() => onToggle(column.key)}
              >
                <span>{column.label}</span>
                <Switch
                  size="small"
                  aria-label={column.label}
                  checked={visibleKeys.includes(column.key)}
                  onClick={(_checked, event) => {
                    event.stopPropagation();
                    onToggle(column.key);
                  }}
                />
              </S.ColumnRow>
            ))}
          </div>
        ))}
      </S.ColumnList>
    </S.DropdownPanel>
  );

  return (
    <Dropdown
      overlay={panel}
      trigger={['click']}
      onVisibleChange={handleVisibleChange}
      placement="bottomRight"
    >
      <Button icon={<BarsOutlined aria-hidden />}>
        Colunas <DownOutlined aria-hidden />
      </Button>
    </Dropdown>
  );
}
